<template>
  <div class="dlParam comWDSParams_viewDP">
    <div class="com_param_div">
      <div class="params_div">
        <span>数据堆叠</span>
        <el-input v-model="config.stack" @change="getRender" placeholder="请输入数据堆叠类型"></el-input>
      </div>
    </div>
    <div class="com_param_div">
      <div class="params_div checkViewConfig">
        <el-checkbox v-model="config.customColor" @change="getColor">自定义颜色</el-checkbox>
      </div>
      <div class="params_div" v-if="config.customColor">
        <span>颜色</span>
        <el-color-picker v-model="config.color" show-alpha @change="getRender"></el-color-picker>
      </div>
    </div>
    <div class="com_param_div">
      <div class="params_div checkViewConfig">
        <el-checkbox v-model="config.label.show" @change="getRender">是否展示数值</el-checkbox>
      </div>
    </div>
    <div class="com_param_div">
      <div class="params_div checkViewConfig">
        <el-checkbox v-model="config.line.smooth" @change="getRender">是否平滑曲线显示</el-checkbox>
      </div>
    </div>
    <div class="com_param_div selViewConfig">
      <div class="params_div">
        <span class="span_til">线的类型</span>
        <el-select v-model="config.line.type" placeholder="请选择线的类型"  @change="getRender">
          <el-option v-for="item in lineList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="params_div">
        <span class="span_til">线宽</span>
        <el-input v-model="config.line.width" @change="getRender" type="number" min="1"></el-input>
        <!-- <span class="unit">px</span> -->
      </div>
    </div>
    <div class="com_param_div selViewConfig">
      <div class="params_div">
        <span class="span_til">标记图形</span>
        <el-select v-model="config.line.symbol" placeholder="请选择标记图形"  @change="getRender">
          <el-option v-for="item in symbolList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="params_div">
        <span class="span_til">标记大小</span>
        <el-input v-model="config.line.symbolsize" @change="getRender" type="number" min="0"></el-input>

        <!-- <div class="unit">px</div> -->
      </div>
    </div>

    <div class="com_param_div numViewConfig numViewConfig_unit">
      <div class="params_div">
        <span class="span_til">描边颜色</span>
        <el-color-picker v-model="config.line.symbolborder" show-alpha @change="getRender"></el-color-picker>
      </div>
      <div class="params_div">
        <span class="span_til">描边线宽</span>
        <el-input v-model="config.line.symbolWidth" @change="getRender" type="number" min="0"></el-input>
      </div>
    </div>
    <div class="com_param_div numViewConfig numViewConfig_unit" v-if="config.line.areashow===true">
      <div class="params_div">
        <span class="span_til">面积颜色</span>
        <el-color-picker v-model="config.line.areaStyle.color" show-alpha @change="getRender"></el-color-picker>
      </div>
      <div class="params_div">
        <span class="span_til">阴影颜色</span>
        <el-color-picker v-model="config.line.areaStyle.shadowColor" show-alpha @change="getRender"></el-color-picker>
      </div>
    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/4/27 10:48 上午
 */
export default {
  name: 'dlParam',
  components: {},

  props: {
    index: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },

  },
  computed: {
    config() {
      if (this.type === 'view') {
        return this.$store.state.viewDP.chart.setting.dlList[this.index].params || {};
      } else if (this.type === 'screen') {
        return this.$store.state.designer.chart.setting.dlList[this.index].params || {};
      }
    },
    nowChart() {
      if (this.type === 'view') {
        return this.$store.state.viewDP.nowChart;
      } else if (this.type === 'screen') {
        return this.$store.state.designer.chart;
      }
    }
  },
  data() {
    return {
      lTAxisList: [
        { value: 0, label: '主轴' },
        { value: 1, label: '次轴' }
      ],
      symbolList: [
        { value: 'circle', label: '圆' },
        { value: 'rect', label: '矩型' },
        { value: 'roundRect', label: '圆矩型' },
        { value: 'pin', label: '标记' },
        { value: 'arrow', label: '箭头' },
        { value: 'none', label: '空' },
        { value: 'triangle', label: '三角形' },
        { value: 'emptyCircle', label: '空心圆' },
        { value: 'diamond', label: '菱形' }
      ],
      lineList: [
        { value: 'solid', label: '实线' },
        { value: 'dashed', label: '虚线' },
        { value: 'dotted', label: '点线' },
      ]
    }
  },
  methods: {
    getRender() {
      if (this.type === 'view') {
        this.$store.dispatch('viewDPRender');
      } else if (this.type === 'screen') {
        this.$store.dispatch('screenRender');
      }
    },
    //颜色
    getColor() {
      if (!this.config.customColor) {
        this.getRender();
        this.config.color = '';
      }
    }
  },
  mounted() {

  },
  destroyed() {

  }
}
</script>

<style lang="less">
.dlParam {
}
</style>
